import React, { Fragment } from 'react';
import './ContractCard.css';

const splitNames = (str) => {
  if (!str || !str.includes(' & ')) return str || 'N/A';
  const parts = str.split(' & ');
  return parts.map((name, i) => (
    <Fragment key={i}>{name}{i < parts.length - 1 && <>{' &'}<br /></>}</Fragment>
  ));
};

const ContractCard = ({ contract, onClick, hideBadges = false, isClosed = false, isSuperAdmin = false }) => {
  const isCancelled = contract?.deal_status === 'cancelled';
  // Parsing dates
  const formatDate = (dateStr) => {
    try {
      if (!dateStr) return 'N/A';
      if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr || 'N/A';

      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      return dateStr || 'N/A';
    }
  };

  const hasIssues = Number(contract.open_compliance_issues_count) > 0;
  const hasOverdue = Number(contract.overdue_tasks_count) > 0;

  const sellerSub = contract.seller_agent_is_subscriber;
  const buyerSub = contract.buyer_agent_is_subscriber;
  let borderColor = null;
  if (sellerSub && buyerSub) borderColor = '#5B8DB8';
  else if (sellerSub) borderColor = '#7FB069';
  else if (buyerSub) borderColor = '#D4A574';

  const keyfloAgents = isSuperAdmin && contract.keyflo_agent_names?.length > 0
    ? contract.keyflo_agent_names
    : null;

  return (
    <div
      className={`contract-card ${isClosed ? 'contract-card-closed' : ''}`}
      onClick={onClick}
      style={borderColor ? { border: `2px solid ${borderColor}` } : undefined}
    >
      {!hideBadges && (
        <div className="badge-group">
          {hasOverdue && (
            <div className="badge-overdue">
              {contract.overdue_tasks_count} Task{contract.overdue_tasks_count !== 1 ? 's' : ''} Overdue
            </div>
          )}
          {hasIssues && (
            <div className="badge-issue">
              {contract.open_compliance_issues_count} Issue{contract.open_compliance_issues_count !== 1 ? 's' : ''}
            </div>
          )}
        </div>
      )}

      <div className="card-body">
        <h3 className="property-address">
          {contract.property_address || `${contract.property_address_city}, ${contract.property_address_state}`}
        </h3>
        <div className="info-row">
          <span className="info-label">Buyer</span>
          <span className="info-value">{splitNames(contract.buyer_name)}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Seller</span>
          <span className="info-value">{splitNames(contract.seller_name)}</span>
        </div>

        <div className="closing-date-section">
          <div className="info-row" style={{ marginBottom: 0 }}>
            <span className="info-label">Closing Date</span>
            <span className="info-value" style={{
              color: contract.close_of_escrow_due_date ? 'var(--accent-green)' : 'var(--text-secondary)',
              fontWeight: 700
            }}>
              {formatDate(contract.close_of_escrow_due_date)}
            </span>
          </div>
        </div>
      </div>

      <div className="card-footer">
        {keyfloAgents && (
          <div className="meta-row" style={{ marginBottom: '4px' }}>
            <span style={{ fontSize: '0.72rem', color: borderColor, fontWeight: 600 }}>
              {keyfloAgents.join(' · ')}
            </span>
          </div>
        )}
        <div className="meta-row">
          {isClosed && (
            <span className={`closed-label${isCancelled ? ' cancelled-label' : ''}`}>
              {isCancelled ? 'CANCELLED' : 'CLOSED'}
            </span>
          )}
          <span>Uploaded: {formatDate(contract.upload_date)}</span>
        </div>
      </div>
    </div>
  );
};

export default ContractCard;
